import React, { useContext } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import LoadingPage from '../../shared/components/LoadingPage/LoadingPage';
import AppLayoutV3 from '../../shared/components/v3/Layouts/AppLayout/AppLayout';
import { DEEPLINK_URL_PARAM, EMPTY_COMPANY_ROUTES, LOGIN_ROUTE, NO_LAYOUT_ROUTES } from '../../shared/constants/auth';
import { PLAN_TYPE_HEALTH } from '../../shared/constants/plan';
import { SessionContext } from '../../shared/context/auth/authContext';
import { CompanyContext } from '../../shared/context/company/companyContext';
import usePermissions from '../../shared/hooks/usePermissions/usePermissions';
import { toLocalStorage } from '../../shared/utils/utils';

interface PrivateRouteProps {
  permissionsRequired?: string[];
  children: React.ReactNode;
}

const PrivateRoute = ({ permissionsRequired = [], children }: PrivateRouteProps) => {
  const { isLoggedIn, isBetterflyer } = useContext(SessionContext);
  const { companyData, companyPlansType } = useContext(CompanyContext);
  const { companyRole, hasAnyAccess } = usePermissions();
  const location = useLocation();
  const path = location.pathname;

  const checkEmptyCompanyRoutes = () => {
    if (!isBetterflyer && !companyData.hasMembers && companyPlansType === PLAN_TYPE_HEALTH) {
      return EMPTY_COMPANY_ROUTES.includes(path);
    }
    return true;
  };

  const renderWithLayout = (path: string): React.ReactNode => {
    if (NO_LAYOUT_ROUTES.includes(path)) {
      return children;
    }
    return <AppLayoutV3>{children}</AppLayoutV3>;
  };

  if (isLoggedIn !== null) {
    if (!isLoggedIn) {
      toLocalStorage(DEEPLINK_URL_PARAM, path);
    }
  }

  if (isLoggedIn === null || (isLoggedIn && !companyRole.permissions?.length)) {
    return <LoadingPage />;
  }

  if (isLoggedIn) {
    if (hasAnyAccess(permissionsRequired) && checkEmptyCompanyRoutes()) {
      return <>{renderWithLayout(path)}</>;
    }
    return <Navigate to={companyRole.defaultRoute} replace />;
  }

  return <Navigate to={LOGIN_ROUTE} replace />;
};

export default PrivateRoute;
